import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FieldArray, Form, Formik } from "formik";
import { StyledRgrl } from "../../styled/Prevencion";
import FormikActions from "../formik/FormikActions";
import FormikAutoSaveOnUnmount from "../formik/FormikAutoSaveOnUnmount";
import CustomStepper from "../stepper/CustomStepper";
import { validatePlanillaTable } from "./defaultPlanillaValidation";
import FilaPlanilla from "./planillaColumns/FilaPlanilla";
import TableTitle from "./TableTitle";

const initialValues = {
  idItemFormularioArt: "",
  secuencia: "",
  pregunta: "",
  resultado: "0",
  seleccionOpcion: "", // Agregamos este campo para el Autocomplete
};

const PlanillaTable = ({
  handleSubmit,
  data,
  tituloGrupo,
  contador,
  totalGrupos,
  handleGoBack,
  capitalizeTitle = true,
  validationSchema = validatePlanillaTable,
  columns,
  disabled,
  handleSaveOnUnmount,
  // Bool que decide si se guarda al desmontar el componente
  saveOnUnmount,
}) => {

  return (
    <>
      <TableTitle
        title={capitalizeTitle
          ? `${tituloGrupo.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
            letter.toUpperCase()
          )}`
          : tituloGrupo
        }
      />
      <Formik
        initialValues={{
          opciones: data.reduce((opciones, sustancia, index) => {
            opciones[index] = { ...initialValues, ...sustancia };
            return opciones;
          }, []),
        }}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        validationSchema={validationSchema}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <FieldArray name="opciones" validateOnChange={false}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell key={column.id}>{column.label}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {values.opciones.map((row, rowIndex) => {
                      return (
                        <TableRow key={rowIndex}>

                          {columns.map((column) => (
                            <TableCell>
                              <FilaPlanilla
                                columnId={column.id}
                                rowValues={row}
                                index={rowIndex}
                                handleChange={handleChange}
                                values={values}
                                initialValues={initialValues}
                                setFieldValue={setFieldValue}
                                disabled={disabled}
                              />
                            </TableCell>
                          ))}
                        </TableRow >
                      );
                    })}
                  </TableBody >
                </Table >
                <CustomStepper contador={contador} maxGrupos={totalGrupos} />
                <StyledRgrl.PlanillaTableButtonContainer>
                  <FormikActions
                    submit={
                      contador === totalGrupos - 1
                        ? "Siguiente paso"
                        : "Grupo siguiente"
                    }
                    handleCancel={
                      contador !== 0 ? () => handleGoBack(values) : null
                    }
                    cancel={contador !== 0 ? "Grupo anterior" : null}
                  />
                </StyledRgrl.PlanillaTableButtonContainer>
              </TableContainer >
            </FieldArray >
            <FormikAutoSaveOnUnmount
              handleSave={handleSaveOnUnmount}
              saveOnUnmountRef={saveOnUnmount}
            />
          </Form >
        )}
      </Formik >
    </>
  );
};

export default PlanillaTable;
